import React, { useEffect, useState } from 'react'
import Header from '../../../components/generals/header'
import stylesIndex from './../../../css/Index.module.css'
import store from '../../../reducer/store'
import DataTableDemo from '../../../components/generals/datatables/datatable'
import styles from '../../../css/reports/Reports.module.css'
import { getData } from '../../../actions/servicesHttp'
import { formatDate } from '../../../components/generals/charts/utils/DatesFormats'
import { Button } from 'reactstrap'
import { NavLink, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import Loading from '../../../components/generals/loading'

export default function DeviceHardwareReport () {
  const { t, ready } = useTranslation('deviceHardwareReport')
  const { user } = store.getState()
  const role = user.roles
  const [urlDevicesHardwareReport] = useState('stats/devices')
  const [hardware, setHardware] = useState(null)
  const navigate = useNavigate()

  const columns = [
    { field: 'identity', header: t('headers.one') },
    { field: 'serial_number', header: t('headers.two') },
    { field: 'type', header: t('headers.three') },
    { field: 'so', header: t('headers.four') },
    { field: 'model', header: t('headers.five') },
    { field: 'IMEI', header: t('headers.six') },
    { field: 'mac', header: t('headers.seven') },
    { field: 'percentDisk', header: t('headers.eight') },
    { field: 'percentRam', header: t('headers.nine') },
    { field: 'percentBattery', header: t('headers.ten') },
    { field: 'capacityBattery', header: t('headers.eleven') }
  ]

  const getDevicesHardwareReport = async () => {
    const response = await getData(urlDevicesHardwareReport, undefined, navigate)

    if (response?.status === 200) {
      const devices = response?.data
      const array = []
      devices.forEach((info) => {
        const Ram = info.Ram.percent
        const Disk = info.Disk.percent
        const Battery = info.Battery
        const device = info.Device

        const soSplit = device?.so?.split('_-_') || []
        const so = soSplit.length > 1 ? `${soSplit[0]} ${soSplit[1]}` : soSplit[0] || ''
        device.so = so

        const modelSplit = device?.model?.split('_-_') || []
        const model = modelSplit.length > 1 ? `${modelSplit[0]} ${modelSplit[1]}` : modelSplit[0] || ''
        device.model = model

        device.last_date = device.last_date === null ? t('noDisponible') : formatDate(device.last_date)

        const element = {
          ...device,
          percentRam: Ram,
          percentDisk: Disk,
          capacityBattery: Battery.capacity,
          percentBattery: Battery.lifePercent,
          temperatureBattery: Battery.temperature
        }

        array.push(element)
      })
      setHardware(array)
    } else {
      setHardware([])
    }
  }

  useEffect(() => {
    if (ready) {
      getDevicesHardwareReport()
    }
  }, [ready])

  return (
    <div className={`content-wrapper  ${stylesIndex.flexContent}`}>
      <div className={`content  ${stylesIndex.mainContent}`}>
        <Header title={t('title')} />
        <div>
          <NavLink to="/mdm/reports">
              <Button variant="dark" className={styles.return_btn}>
                <i className="pi pi-arrow-circle-left" style={{ marginRight: '0.5rem' }}></i>
                {t('button')}
              </Button>
          </NavLink>
        </div>
        <div style={{ marginTop: '1rem' }}>
          {hardware === null && <Loading color="primary" />}
          {hardware !== null && <DataTableDemo
            data={hardware}
            reload={() => getDevicesHardwareReport()}
            editUsers={false}
            rowStates={false}
            rowSelecteds={false}
            exportsPdf={role?.reportsPage.exportPdfInReport}
            exportsCsv={role?.reportsPage.exportCsvInReport}
            actionDelete={false}
            actionDashboard={false}
            table="deviceHardwareReport"
            searchs={['serial_number', 'identity']}
            columns={columns}
            namePdf={t('namePdf')}
          />}
        </div>
      </div>
    </div>
  )
}
